import Vue from 'vue';
import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

Vue.use(VueI18n);

const messages = {
  en,
  es,
  pt
};

// puedes obtener el idioma del backend (Laravel) o del navegador
const locale = document.documentElement.lang || 'es';

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  messages
});

export default i18n;